import { Source, Transaction } from "types";
import { getEarningReportTransactionsParams } from "../models/Reports";
import { useEarningsReportFilterStore } from "../stores/reports/earningsReportFilterStore";
import { useInfiniteCollection } from "./useInfiniteCollection";

export const useEarningReportParams = () => {
    const filters = useEarningsReportFilterStore((state) => state.filters);
    const dateParams = useEarningsReportFilterStore((state) => state.getDateParams());
    const params = getEarningReportTransactionsParams(dateParams, filters);

    const { data: transactions, ...rest } = useInfiniteCollection<Transaction>("transactions", params, {
        // TODO: Enabled for full date range only
        // same as Custom reports, to refetch everytime when there is change in filters/date to show updated data always
        staleTime: 100,
    });

    // Modify returned data to add a "reservationist" column that depends on the source...
    const modifiedTransactions = transactions.map((transaction) => {
        const name = transaction.source === Source.CHECKOUT ? "Checkout" : null;
        const id = transaction.createdBy?.id;
        return {
            ...transaction,
            reservationist: {
                id,
                name,
            },
        };
    });

    return { params, transactions: modifiedTransactions, filters, ...rest };
};
